import script from "./BulkUpdateListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkUpdateListView.vue?vue&type=script&setup=true&lang=ts"

import "./BulkUpdateListView.vue?vue&type=style&index=0&id=26c5044e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c5044e"]])

export default __exports__